import { muiColors, socnaColors } from '@e-socna/colors';
import { SocnaColorEnum } from '@e-socna/data-layer';

export interface ThemeColor {
  readonly label: string;
  readonly hex: string;
}

export const DEFAULT_THEME_COLOR: ThemeColor = {
  label: 'Couleur par défaut',
  hex: muiColors.primary,
};

export const SOCNA_THEME_COLORS: Readonly<Record<SocnaColorEnum, ThemeColor>> =
  {
    [SocnaColorEnum.SocnaIng]: {
      label: 'SOCNA Ing',
      hex: socnaColors.socnaIng,
    },
    [SocnaColorEnum.SocnaSols]: {
      label: 'SOCNA Sols',
      hex: socnaColors.socnaSols,
    },
    [SocnaColorEnum.SocnaReseaux]: {
      label: 'SOCNA Réseaux',
      hex: socnaColors.socnaReseaux,
    },
    [SocnaColorEnum.SocnaInternational]: {
      label: 'SOCNA International',
      hex: socnaColors.socnaInternational,
    },
    [SocnaColorEnum.SocnaLab]: {
      label: 'SOCNA Lab',
      hex: socnaColors.socnaLab,
    },
  };
